export const CAPABILITY_TYPES = [
  "air_temperature",
  "air_humidity",
  "temperature",
  "relative_humidity",
  "barometric_pressure",
  "luminosity",
  "uv_index",
  "co2",
  "tvoc",
  "pm2_5",
  "pm10",
  "battery",
  "voltage",
  "current",
  "power",
  "energy",
  "wind_speed",
  "wind_direction",
  "rain",
  "rain_total",
  "soil_moisture",
  "soil_conductivity",
  "motion",
  "door",
  "leak",
  "presence",
  "digital_sensor",
  "analog_sensor",
  "accelerometer",
  "gyrometer",
  "gps",
];

export const CAPABILITY_UNITS = [
  "c",
  "F",
  "%",
  "hPa",
  "lux",
  "m/s",
  "km/h",
  "mm",
  "m",
  "V",
  "mV",
  "mA",
  "A",
  "W",
  "kWh",
  "ppm",
  "ppb",
  "uS/cm",
  "µg/m³",
  "dB",
  "d",
];
